import type { NamedFieldProps } from "shared/react";
import type { CreatorEntity } from "shared/schema";
import { EntitySchema, type ValueCallback, assertInstance } from "shelving";
import { useStore } from "shelving/react";
import { Field, Loader, useDialog, useField } from "shared/react";
import { EntityButton } from "../entity/EntityButton.js";
import { CreatorPicker } from "./CreatorPicker.js";

/** Field in a form that lets you choose the creator of something. */
export function CreatorField(props: NamedFieldProps): React.ReactElement {
	const field = useField<CreatorEntity | null>(props);
	const { name, form, schema } = field;
	useStore(form);
	assertInstance(schema, EntitySchema);
	return (
		<Field {...field}>
			<CreatorInput mods="space-none" onChange={c => form.setProp(name, c)} {...field} />
		</Field>
	);
}

export function CreatorInput({
	mods = "",
	placeholder = "No creator",
	value,
	onChange,
}: {
	mods?: string | undefined;
	placeholder?: string | undefined;
	value?: CreatorEntity | null | undefined;
	onChange: ValueCallback<CreatorEntity>;
}): React.ReactElement {
	const showDialog = useDialog();
	return (
		<button
			type="button"
			className={`input ${mods} ${value ? "" : "input-placeholder"} size-small`}
			onClick={() => {
				showDialog(
					<article className="modal">
						<Loader>
							<CreatorPicker onPick={c => onChange(c)} creator={value} />
						</Loader>
					</article>,
				);
			}}
		>
			{value ? <EntityButton entity={value} disabled mods="flex-fit" /> : placeholder}
		</button>
	);
}
